import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import './styles.css'

function CourseArtist({ title, slug, intro = '', photo }) {
  return (
    <section id="course-artist">
      <div className="wrapper-1080">
        <div className="info">
          <h2>
            <span className="header">Artist Biography</span>
            <span className="name">{title}</span>
          </h2>
          <div className="intro">{intro}</div>
          <Link className="see-more" to={`/artists/${slug}`}>
            <i className="icon-plus" />
            See Full Bio
          </Link>
        </div>
        {photo && photo.boxThumb && (
          <div className="photo">
            <span><img src={photo.boxThumb} role="presentation" alt="" /></span>
          </div>
        )}
      </div>
    </section>
  )
}

CourseArtist.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  intro: PropTypes.string,
  photo: PropTypes.objectOf(PropTypes.string).isRequired
}

export default CourseArtist
